<template>
  <div>
    <div class="das_top_cont">
      <div class="history_box">
        <div class="accountright_cont_box">
          <div class="flex_center_between_box" style="">
            <h2 class="history_box-head">
              {{ $t("ContactInfo.ContactInfo") }}
            </h2>

            <div class="flex_center">
              <el-radio v-model="radio" label="1">{{
                $t("ContactInfo.Setascontactperson")
              }}</el-radio>
              <button
                class="btn_blue flex_center btn_eee change_btn"
                v-if="Edit"
                @click="Edit = !Edit"
              >
                {{ $t("ContactInfo.Edit") }}
              </button>
              <div v-else style="display: flex">
                <button
                  class="btn_blue flex_center change_btn_mr10"
                  @click="ChangeOwnership(1)"
                >
                  {{ $t("MyAccount.Save") }}
                </button>
                <button
                  class="btn_blue flex_center change_btn_gray"
                  @click="CanselList(1)"
                >
                  {{ $t("MyAccount.Cancel") }}
                </button>
              </div>
            </div>
          </div>
          <div class="his_sel_box margin-top10">
            <div class="information-content">
              <div class="sel_box computer_right_cont_box">
                <el-input
                  class="inline-input"
                  :disabled="Edit"
                  clearable
                  v-model="Enterprisecertification.firstName"
                  :placeholder="$t('ContactInfo.FirstName')"
                ></el-input>
              </div>
              <div class="sel_box computer_right_cont_box">
                <el-input
                  class="inline-input"
                  :disabled="Edit"
                  clearable
                  v-model="Enterprisecertification.address1"
                  :placeholder="$t('ContactInfo.AddressLine')"
                ></el-input>
              </div>
            </div>
            <div class="information-content account_form_itemA">
              <div class="sel_box computer_right_cont_box">
                <el-input
                  class="inline-input"
                  :disabled="Edit"
                  clearable
                  v-model="Enterprisecertification.lastName"
                  :placeholder="$t('ContactInfo.LastName')"
                ></el-input>
              </div>
              <div class="sel_box computer_right_cont_box">
                <el-input
                  class="inline-input"
                  :disabled="Edit"
                  clearable
                  v-model="Enterprisecertification.address2"
                  :placeholder="$t('ContactInfo.AddressLine')"
                ></el-input>
              </div>
            </div>
            <div class="information-content account_form_itemA">
              <div class="sel_box computer_right_cont_box">
                <el-input
                  class="inline-input"
                  :disabled="Edit"
                  clearable
                  v-model="Enterprisecertification.phoneNumber"
                  :placeholder="$t('ContactInfo.PhoneNumber')"
                ></el-input>
              </div>
              <div class="sel_box computer_right_cont_box">
                <el-input
                  class="inline-input"
                  :disabled="Edit"
                  clearable
                  v-model="Enterprisecertification.city"
                  :placeholder="$t('ContactInfo.City')"
                ></el-input>
              </div>
            </div>
            <div class="information-content account_form_itemA">
              <div class="sel_box computer_right_cont_box">
                <el-input
                  class="inline-input"
                  :disabled="Edit"
                  clearable
                  v-model="Enterprisecertification.email"
                  :placeholder="$t('ContactInfo.Email')"
                ></el-input>
              </div>
              <div class="sel_box computer_right_cont_box">
                <el-input
                  class="inline-input"
                  :disabled="Edit"
                  clearable
                  v-model="Enterprisecertification.zipCode"
                  :placeholder="$t('ContactInfo.ZipCode')"
                ></el-input>
              </div>
            </div>
            <div class="information-content account_form_itemA">
              <div class="sel_box computer_right_cont_box">
                <el-select
                  style="width: 100%"
                  :disabled="Edit"
                  filterable
                  v-model="Enterprisecertification.countryCode"
                  :placeholder="$t('ContactInfo.CountryRegion')"
                  class="fin_top_sel"
                  @change="changeCountry"
                >
                  <el-option
                    v-for="item in countryOptions"
                    :key="item.countryCode"
                    :label="item.nameEn"
                    :value="item.countryCode"
                  ></el-option>
                </el-select>
              </div>
            </div>
          </div>
        </div>
        <div class="accountright_cont_box margin-top10">
          <div class="flex_center_between_box" style="">
            <h2 class="history_box-head">
              {{ $t("ContactInfo.Alternativecontactperson") }}
            </h2>

            <div class="flex_center">
              <el-radio v-model="radio" label="2">
                {{ $t("ContactInfo.Setascontactperson") }}</el-radio
              >
              <button
                class="btn_blue flex_center btn_eee change_btn"
                v-if="Edittwo"
                @click="Edittwo = !Edittwo"
              >
                {{ $t("ContactInfo.Edit") }}
              </button>
              <div v-else style="display: flex">
                <button
                  class="btn_blue flex_center change_btn_mr10"
                  @click="ChangeOwnership(2)"
                >
                  {{ $t("MyAccount.Save") }}
                </button>
                <button
                  class="btn_blue flex_center change_btn_gray"
                  @click="CanselList(2)"
                >
                  {{ $t("MyAccount.Cancel") }}
                </button>
              </div>
            </div>
          </div>
          <div class="his_sel_box margin-top10">
            <div class="information-content">
              <div class="sel_box computer_right_cont_box">
                <el-input
                  class="inline-input"
                  :disabled="Edittwo"
                  clearable
                  v-model="Peoplecertification.firstName"
                  :placeholder="$t('ContactInfo.FirstName')"
                ></el-input>
              </div>
              <div class="sel_box computer_right_cont_box">
                <el-input
                  class="inline-input"
                  :disabled="Edittwo"
                  clearable
                  v-model="Peoplecertification.address1"
                  :placeholder="$t('ContactInfo.AddressLine')"
                ></el-input>
              </div>
            </div>
            <div class="information-content account_form_itemA">
              <div class="sel_box computer_right_cont_box">
                <el-input
                  class="inline-input"
                  :disabled="Edittwo"
                  clearable
                  v-model="Peoplecertification.lastName"
                  :placeholder="$t('ContactInfo.LastName')"
                ></el-input>
              </div>
              <div class="sel_box computer_right_cont_box">
                <el-input
                  class="inline-input"
                  :disabled="Edittwo"
                  clearable
                  v-model="Peoplecertification.address2"
                  :placeholder="$t('ContactInfo.AddressLine')"
                ></el-input>
              </div>
            </div>
            <div class="information-content account_form_itemA">
              <div class="sel_box computer_right_cont_box">
                <el-input
                  class="inline-input"
                  :disabled="Edittwo"
                  clearable
                  v-model="Peoplecertification.phoneNumber"
                  :placeholder="$t('ContactInfo.PhoneNumber')"
                ></el-input>
              </div>
              <div class="sel_box computer_right_cont_box">
                <el-input
                  class="inline-input"
                  :disabled="Edittwo"
                  clearable
                  v-model="Peoplecertification.city"
                  :placeholder="$t('ContactInfo.City')"
                ></el-input>
              </div>
            </div>
            <div class="information-content account_form_itemA">
              <div class="sel_box computer_right_cont_box">
                <el-input
                  class="inline-input"
                  :disabled="Edittwo"
                  clearable
                  v-model="Peoplecertification.email"
                  :placeholder="$t('ContactInfo.Email')"
                ></el-input>
              </div>
              <div class="sel_box computer_right_cont_box">
                <el-input
                  class="inline-input"
                  :disabled="Edittwo"
                  clearable
                  v-model="Peoplecertification.zipCode"
                  :placeholder="$t('ContactInfo.ZipCode')"
                ></el-input>
              </div>
            </div>
            <div class="information-content account_form_itemA">
              <div class="sel_box computer_right_cont_box">
                <el-select
                  style="width: 100%"
                  :disabled="Edittwo"
                  filterable
                  v-model="Peoplecertification.countryCode"
                  :placeholder="$t('ContactInfo.CountryRegion')"
                  class="fin_top_sel"
                  @change="changeCountry"
                >
                  <el-option
                    v-for="item in countryOptions"
                    :key="item.countryCode"
                    :label="item.nameEn"
                    :value="item.countryCode"
                  ></el-option>
                </el-select>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ReLogin :reLoginPop="reLoginVis"></ReLogin>
  </div>
</template>
<script>
import { mixins1 } from "@/mixins/index";
import { setContactPerson, getUserContactPersons } from "@/api/api.js";
import ReLogin from "../../../components/ReLogin.vue";

export default {
  mixins: [mixins1],
  components: {
    ReLogin,
  },
  data() {
    return {
      reLoginVis: false,
      value1: "",
      CategoryVal: "",

      window: window,
      Edit: true,
      Edittwo: true,
      radio: 0,
      countryOptions: [],
      Enterprisecertification: {
        isAlterContactPerson: "",
        isContactPerson: "",
        firstName: "",
        lastName: "",
        phoneNumber: "",
        email: "",
        countryCode: "",
        address1: "",
        city: "",
        zipCode: "",
        address2: "",
      },
      Peoplecertification: {
        isContactPerson: "",
        isAlterContactPerson: "",
        isContact: this.radio2,
        firstName: "",
        lastName: "",
        phoneNumber: "",
        email: "",
        countryCode: "",
        address1: "",
        address2: "",
        city: "",
        zipCode: "",
      },
    };
  },
  beforeDestroy() {},
  destroyed() {},
  created() {
    this.getUserContactPersonsList();
  },
  mounted() {
    this.getCountry();
  },

  methods: {
    CanselList(value) {
      if (value == 2) {
        this.Edittwo = !this.Edittwo;
      } else {
        this.Edit = !this.Edit;
      }
      this.Peoplecertification = {
        isAlterContactPerson: "",
        isContactPerson: "",
        firstName: "",
        lastName: "",
        phoneNumber: "",
        email: "",
        countryCode: "",
        address1: "",
        address2: "",
        city: "",
        zipCode: "",
      };
      this.Enterprisecertification = {
        isAlterContactPerson: "",
        isContactPerson: "",
        firstName: "",
        lastName: "",
        phoneNumber: "",
        email: "",
        countryCode: "",
        address1: "",
        address2: "",
        city: "",
        zipCode: "",
      };
      this.getUserContactPersonsList();
    },
    getUserContactPersonsList() {
      getUserContactPersons()
        .then((res) => {
          if (res.code == 200) {
            if (res.data.alt != null) {
              this.Peoplecertification = {
                isAlterContactPerson: res.data.alt.isAlter,
                isContactPerson: res.data.alt.isContact,
                firstName: res.data.alt.firstName,
                lastName: res.data.alt.lastName,
                phoneNumber: res.data.alt.phoneNumber,
                email: res.data.alt.email,
                countryCode: res.data.alt.countryRegion,
                address1: res.data.alt.address,
                address2: res.data.alt.address2,
                city: res.data.alt.city,
                zipCode: res.data.alt.zipCode,
              };
              this.radio = res.data.alt.isContact.toString() == "0" ? "2" : "1";
            }

            if (res.data.con != null) {
              this.Enterprisecertification = {
                isAlterContactPerson: res.data.con.isAlter,
                isContactPerson: res.data.con.isContact,
                firstName: res.data.con.firstName,
                lastName: res.data.con.lastName,
                phoneNumber: res.data.con.phoneNumber,
                email: res.data.con.email,
                countryCode: res.data.con.countryRegion,
                address1: res.data.con.address,
                address2: res.data.con.address2,
                city: res.data.con.city,
                zipCode: res.data.con.zipCode,
              };

              this.radio = res.data.con.isContact.toString() == "0" ? "2" : "1";
            }
          }
        })
        .catch((err) => {
          this.reLoginVis = String(err).includes("403");
        });
    },
    //获取国家
    getCountry() {
      this.countryOptions = JSON.parse(
        localStorage.getItem("countryList"),
      )[0].countryList;
    },
    changeCountry() {
      this.Peoplecertification.city = "";
      this.Enterprisecertification.city = "";
      this.provinceOptions = [];
      if (
        this.Peoplecertification.countryCode ||
        this.Enterprisecertification.countryCode
      ) {
      }
    },
    handleSelectionChange() {
      val;
    },
    // 认证
    ChangeOwnership(value) {
      let params = {};
      if (value == 1) {
        this.Enterprisecertification.isContactPerson =
          this.radio == "1" ? "1" : "0";
        this.Enterprisecertification.isAlterContactPerson = 0;
        params = this.Enterprisecertification;
      } else {
        this.Peoplecertification.isContactPerson =
          this.radio == "2" ? "1" : "0";
        this.Peoplecertification.isAlterContactPerson = 1;

        params = this.Peoplecertification;
      }

      setContactPerson(params).then((res) => {
        if (res.code == -1) {
          this.$message({
            message: res.msg,
            center: true,
            type: "error",
          });
        } else {
          if (value == 1) {
            this.Edit = true;
          }
          if (value == 2) {
            this.Edittwo = true;
          }
          this.getUserContactPersonsList();
          this.$message({
            message: res.msg,
            center: true,
            type: "success",
          });
        }
      });
    },
  },
};
</script>
<style scoped>
.flex_center_between_box {
  display: flex;
  justify-content: space-between;
}

.history_box-head {
  font-size: 24px !important;
  line-height: 28px !important;
}

.sel_box {
  width: 40%;
  min-width: 530px;
  position: relative;
}

.sel_box /deep/ .el-input__inner {
  height: 50px !important;
  line-height: 50px !important;
  border-color: #ccc !important;
  border-radius: 10px;
  font-size: 20px;
  padding-left: 10px !important;
  color: #1a2332;
}

.information-content {
  display: flex;
}
.account_form_itemA {
  align-items: center;
  margin-top: 16px !important;
  margin-bottom: 0 !important;
}
.his_sel_box .information-content {
  justify-content: flex-start;
  gap: 40px;
}
.btn_eee {
  background: #eee !important;
  color: #1a2332;
}
.el-select-dropdown__item {
  font-size: 20px !important;
  color: #1a2332;
}
/deep/ .el-radio__label {
  font-size: 20px;
  color: #1a2332;
}
@media screen and (max-width: 1920px) {
  .history_box-head {
    font-size: 20px !important;
    line-height: 24px !important;
  }
  .account_form_itemA {
    margin-top: 12px !important;
  }
  .his_sel_box .information-content {
    gap: 30px;
  }
  .el-select-dropdown__item {
    font-size: 16px !important;
  }
  /deep/ .el-radio__label {
    font-size: 16px;
  }
  .sel_box {
    min-width: 400px;
  }

  .sel_box /deep/ .el-input__inner {
    height: 36px !important;
    line-height: 36px !important;
    border-radius: 7px;
    font-size: 16px;
  }
}
@media screen and (max-width: 1441px) {
  .history_box-head {
    font-size: 20px !important;
    line-height: 24px !important;
  }
  .account_form_itemA {
    margin-top: 10px !important;
  }
  .his_sel_box .information-content {
    gap: 26px;
  }
  .el-select-dropdown__item {
    font-size: 16px !important;
  }
  /deep/ .el-radio__label {
    font-size: 16px;
  }
  .sel_box {
    min-width: 360px;
  }

  .sel_box /deep/ .el-input__inner {
    height: 32px !important;
    line-height: 32px !important;
    border-radius: 6px;
    font-size: 14px;
  }
}
</style>
